import { cn } from "@breakout/ui/utils"
import { Badge } from "./Badge"

export type StatusVariant =
	| "active"
	| "pending"
	| "closed"
	| "winner"
	| "claimed"
	| "finalized"
	| "ended"

interface StatusBadgeProps {
	children: React.ReactNode
	variant: StatusVariant
	className?: string
}

// Use opacity-based colors that work in both light and dark modes
const statusStyles: Record<StatusVariant, string> = {
	// Green states - positive/active
	active: "border-emerald-500/30 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
	winner: "border-emerald-500/30 bg-emerald-500/10 text-emerald-600 dark:text-emerald-400",
	// Amber states - warning/pending
	pending: "border-amber-500/30 bg-amber-500/10 text-amber-600 dark:text-amber-400",
	// Neutral states - closed/ended
	closed: "border-border-subtle bg-bg-tertiary text-text-muted",
	claimed: "border-border-subtle bg-bg-tertiary text-text-muted",
	finalized: "border-border-subtle bg-bg-tertiary text-text-muted",
	ended: "border-border-subtle bg-bg-tertiary text-text-muted",
}

export function StatusBadge({ children, variant, className }: StatusBadgeProps) {
	return <Badge className={cn(statusStyles[variant], className)}>{children}</Badge>
}
